import { apigClient } from "@/shared/api";

export const roleService = {
  create,
  get
};

function create(bodyParams) {
  return new Promise((resolve, reject) => {
    // wrap in timeout to simulate server api call
    setTimeout(() => {
      var method = "POST";
      var pathTemplate = "/roles";
      var additionalParams = {};
      var pathParams = {};
      apigClient
        .invokeApi(
          pathParams,
          pathTemplate,
          method,
          additionalParams,
          bodyParams
        )
        .then(function(results) {
          var data = results["data"]["data"];
          return data;
          //This is where you would put a success callback
        })
        .catch(function(err) {
          console.log("ERROR ! Cannot create data:" + err);
          reject({
            error: true,
            text: () => Promise.resolve(JSON.stringify(err))
          });
          //This is where you would put an error callback
        });
    });
  });
}

function get() {
  return new Promise((resolve, reject) => {
    // wrap in timeout to simulate server api call
    setTimeout(() => {
      var method = "GET";
      var pathTemplate = "/roles";
      var additionalParams = {};
      var pathParams = {};
      var that = this;
      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(results) {
          that.logData = results["data"]["data"];
        })
        .catch(function(err) {
          console.log("ERROR ! Cannot get data:" + err);
          reject({
            error: true,
            text: () => Promise.resolve(JSON.stringify(err))
          });
          //This is where you would put an error callback
        });
    });
  });
}
